import React, { useRef, useState } from 'react'
import styled from 'styled-components'

import { ScrollToTopOfPageComponent } from '../Common'
import { Navbar } from '../Navbar'
import { MenuLayoutProps } from './MenuLayout.props'
import { Footer } from '../Footer'
import { useRouter } from 'next/router'

export const MenuLayout: React.ComponentType<MenuLayoutProps> = (props) => {
  const {
    menuItems,
    children,
    footer,
    suggestedMenus,
    labels,
    topStrip,
    searchBox,
  } = props
  const [drawerOpen, setDrawerOpen] = useState(false)
  const router = useRouter()

  const isIndexPage = router.asPath.split('?')[0] === '/'
  const isProfilePage = router.pathname === '/profile/[[...tab]]'
  const mainRef = useRef(null)
  const drawerToggleHandler = () => {
    setDrawerOpen(!drawerOpen)
  }

  return (
    <Container
      id="layout"
      background={isProfilePage ? 'lightgrey' : 'lightergrey'}
    >
      <Navbar
        menuItems={menuItems}
        drawerOpen={drawerOpen}
        handleOpen={setDrawerOpen}
        drawerToggleHandler={drawerToggleHandler}
        isIndex={isIndexPage}
        suggestedMenus={suggestedMenus}
        mainRef={mainRef}
        labels={labels}
        topStrip={topStrip}
        searchBox={searchBox}
      />
      <Content ref={mainRef}>{children}</Content>
      <ScrollToTopOfPageComponent />
      <Footer {...footer} />
    </Container>
  )
}

const Container = styled.div<{ background: any }>`
  height: 100%;
  background: ${(props) => props.theme.palette[props.background]};
`

const Content = styled.div`
  transition: transform 0.3s ease-out;
  position: relative;
  z-index: 3;

  @media (min-width: 1280px) {
    margin-left: auto;
    margin-right: auto;
  }
`
